.sidenav-content {
  position: relative;
  z-index: 30000;
}
.clickable {
  cursor: pointer;
  pointer-events: all;
}

.nav-logo {
  float: left;
  padding: 8px 8px;
  /* width: 100%; */
  height: 38px;
}
@media only screen and (max-width: 400px) {
  .nav-logo {
    max-width: 50vw;
  }
}
@media only screen and (max-width: 340px) {
  .nav-logo {
    max-width: 45vw;
  }
}
@media only screen and (max-width: 300px) {
  .nav-logo {
    max-width: 40vw;
  }
}
@media only screen and (max-width: 260px) {
  .nav-logo {
    max-width: 30vw;
  }
}
@media only screen and (max-width: 220px) {
  .nav-logo {
    display: none !important;
  }
  .sidenav-logo {
    display: block !important;
  }
}

.sidenav-logo {
  height: 36px;
}

.nav-button-icon {
  transform: translateY(-2px);
}

@media only screen and (max-width: 1160px) {
  .nav-button-max-width-900 {
    display: none !important;
  }
}

.nav-title {
  padding-left: 8px;
}

@media only screen and (min-width: 1160px) {
  .nav-menu-button {
    display: none !important;
  }

  .nav-button-icon {
    display: none !important;
  }

  .nav-title {
    padding-left: 24px;
  }

  .nav-logo {
    margin-left: 16px;
  }
}

@media only screen and (min-width: 680px) {
  .ion-hide-md-up {
    display: none;
  }
}
@media only screen and (max-width: 680px) {
  .ion-hide-md-down {
    display: none;
  }
}
@media only screen and (min-width: 440px) {
  .ion-hide-sm-up {
    display: none;
  }
}
@media only screen and (max-width: 440px) {
  .ion-hide-sm-down {
    display: none;
  }
}
